<jhi-custom-box [title]="user ? 'spans.changePin.boxtitle' : 'spans.changePin.boxtitlenouser'"
                [errorMsg]="errorMsg"
                [translateParams]="{username: user?.login}"
                [boxSize]="'box-550'"
                [successMsg]="successMsg"
                [contentLoading]="loading"
                (successEmitter)="backToApp()"
                (failureEmitter)="backToApp()"
>
    <form [formGroup]="pinForm">

        <div class="form-group">
            <div class="row">
                <div class="col-sm-4 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" jhiTranslate="spans.changePin.formlabels.username"> Username </label>
                </div>

                <div class="col-sm-8">
                    <span class="font-weight-bold">{{ user?.login }}</span>
                </div>
            </div>

            <div class="row m-t-5">
                <div class="col-sm-4 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" jhiTranslate="spans.changePin.formlabels.firstName"> First name </label>
                </div>
                <div class="col-sm-8">
                    <span class="font-weight-bold">{{ user?.firstName }}</span>
                </div>
            </div>

            <div class="row m-t-5">
                <div class="col-sm-4 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" jhiTranslate="spans.changePin.formlabels.lastName"> Last name </label>
                </div>
                <div class="col-sm-8">
                    <span class="font-weight-bold">{{ user?.lastName }}</span>
                </div>
            </div>

            <div class="row m-t-5">
                <div class="col-sm-4 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" for="pin-input" jhiTranslate="spans.changePin.formlabels.pin"> Pin </label>
                </div>
                <div class="col-sm-8 input-group">
                    <input [readOnly]="submitted" [placeholder]="'spans.changePin.formplaceholders.pin' | translate" id="pin-input"
                           [type]="showPin ? 'text' : 'password'" [formControlName]="'pin'" class="form-control"
                           [ngClass]="errorCheck && f.pin.errors ? 'is-invalid': ''"
                           maxlength="5" pattern="[0-9]{5}" />
                    <div class="input-group-append">
                        <button title="{{showPin ? 'spans.editAccountInfo.hidePin' : 'spans.editAccountInfo.showPin' | translate}}"
                                type="button" class="btn btn-outline-secondary align-self-start" (click)="changeShowPin()">
                            <fa-icon [icon]="showPin ? faEye : faEyeSlash"></fa-icon>
                        </button>
                    </div>
                </div>
                <div class="col-sm-4"></div>
                <div class="col-sm-8 align-self-end">
                    <div *ngIf="fPin.invalid" class="error-box">
                        <span *ngIf="fPin.errors?.pattern" jhiTranslate="spans.editAccountInfo.formerrors.invalidPin"> Invalid pin </span>
                    </div>
                </div>
            </div>
        </div>


        <div class="row text-center d-flex">
            <div class="col-12">
                <button [disabled]="submitted" type="button" class="btn secondary-btn float-left" (click)="backToApp()"
                        jhiTranslate="buttons.back">Return to application</button>
                <button [disabled]="submitted" (click)="onReset()" class="btn secondary-btn" jhiTranslate="buttons.discard">Discard</button>
                <button [ladda]="submitted" class="btn confirm-btn ladda-button max-w-150"
                        data-style="expand-right" (click)="onSubmit()">
                    <span class="ladda-label" jhiTranslate="buttons.submit"></span>
                </button>
            </div>

        </div>
    </form>
</jhi-custom-box>
